import Box from '@mui/material/Box';
import type { FC } from 'react';

import TextFieldDebounce from './TextFieldDebounce';

interface Props {
  searchTerm: string;
  onSearchTermChange: (searchTerm: string) => void;
}

const SearchBar: FC<Props> = ({ searchTerm, onSearchTermChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 1.5,
        alignItems: 'center',
        '& .MuiTextField-root': {
          minWidth: '200px',
          maxWidth: '280px',
        },
        '& .MuiOutlinedInput-root': {
          height: '40px',
          borderRadius: '8px',
          backgroundColor: 'background.default',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          '&.Mui-focused': {
            backgroundColor: 'background.paper',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
              borderWidth: '2px',
            },
          },
        },
      }}
    >
      <TextFieldDebounce value={searchTerm} onChange={onSearchTermChange} placeholder="Buscar" />
    </Box>
  );
};

export default SearchBar;
